import { Button, FormLabel, Stack, Wrap } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import React from 'react';
import { SearchTypeFilter } from '../SearchResults/__generated__/searchQuery.graphql';

interface TypeFilterProps {
  activeTypes: SearchTypeFilter[];
  onFilterChanged(activeTypes: SearchTypeFilter[]): void;
}

export const TypeFilter = ({
  activeTypes,
  onFilterChanged,
}: TypeFilterProps) => {
  return (
    <Stack>
      <FormLabel fontSize="sm">{t`Types`}</FormLabel>
      <Wrap>
        <TypeFilterButton
          type="MEMBER"
          title={t`Member`}
          onChange={onFilterChanged}
          activeTypes={activeTypes}
        />
        <TypeFilterButton
          type="SPACE"
          title={t`Space`}
          onChange={onFilterChanged}
          activeTypes={activeTypes}
        />
        <TypeFilterButton
          type="EVENT"
          title={t`Event`}
          onChange={onFilterChanged}
          activeTypes={activeTypes}
        />
        <TypeFilterButton
          type="ANNOUNCEMENT"
          title={t`Announcement`}
          onChange={onFilterChanged}
          activeTypes={activeTypes}
        />
        <TypeFilterButton
          type="FOLDER"
          title={t`Folder`}
          onChange={onFilterChanged}
          activeTypes={activeTypes}
        />
        <TypeFilterButton
          type="FILE"
          title={t`File`}
          onChange={onFilterChanged}
          activeTypes={activeTypes}
        />
        <TypeFilterButton
          type="FORM"
          title={t`Form`}
          onChange={onFilterChanged}
          activeTypes={activeTypes}
        />
        <TypeFilterButton
          type="PAGE"
          title={t`Page`}
          onChange={onFilterChanged}
          activeTypes={activeTypes}
        />
      </Wrap>
    </Stack>
  );
};

interface TypeFilterButtonProps {
  type: SearchTypeFilter;
  title: string;
  activeTypes: SearchTypeFilter[];
  onChange(newActiveFilters: SearchTypeFilter[]): void;
}

const TypeFilterButton = ({
  type,
  title,
  activeTypes,
  onChange,
}: TypeFilterButtonProps) => {
  const isActive = activeTypes.includes(type);
  return (
    <Button
      isActive={isActive}
      onClick={() =>
        onChange(
          isActive
            ? activeTypes.filter((t) => t !== type)
            : [...activeTypes, type],
        )
      }
      size="xs"
    >
      {title}
    </Button>
  );
};
